import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.services';
import { DataDirectoryService } from '../data-directory/data-directory.service';
import { ToastMessageService } from 'src/app/toastr.service';

@Component({
  selector: 'app-costing-page-new',
  templateUrl: './costing-page-new.component.html',
  styleUrls: ['./costing-page-new.component.scss']
})
export class CostingPageNewComponent implements OnInit {

  allMoleculeData;
  searchValue = '';
  ndaId = '';
  novelpolymorph = '';
  ndanumber = '';
  generalize = '';
  atcclass = '';
  ncepasses = '';
  message: any = '';
  email: any;

  constructor(private toastService: ToastMessageService, private homeservice: HomeService, private directoryservice: DataDirectoryService) {
  }


  ngOnInit(): void {
    this.email = localStorage.getItem("email");
  }

  clearFilter() {
    this.searchValue = ""
    this.allMoleculeData = []
  }

  searchMolecule() {
    let data = {
      atc_class: this.searchValue,
      user_email: this.email
    }
    this.homeservice.getNdaMoleculeData(data).subscribe((response) => {
      this.allMoleculeData = response['data']['data']
      for (let i = 0; i < this.allMoleculeData.length; i++) {
        this.allMoleculeData[i].novelPolymorph = false;
        this.novelpolymorph = this.allMoleculeData[i]['Novel Polymorph(YES/NO)'];
        this.ndanumber = this.allMoleculeData[i]['NDA number'];
        this.generalize = this.allMoleculeData[i]['Genericized?(YES/NO)'];
        this.ncepasses = this.allMoleculeData[i]['NCE-1 passed?(YES/NO)'];
      }


      if (response['message'] == 'success') {
        this.toastService.success('Data Fetched Successfully');
        return;
      }
      else {
        this.toastService.error('Data Not Found !');
        return;
      }
    })
  }

  saveMolecule(ncePassed, beforeNcedata, afterNcedata, ndaNumber, genericName) {
    let data = {
      user_mail: this.email,
      value: beforeNcedata,
      nda_number: ndaNumber,
      Generic_name: genericName
    }

    if (ncePassed == 'YES') {
      data.value = afterNcedata
    }

    if (!data.nda_number || !data.Generic_name) {
      this.toastService.error('Missing required field !');
      return;
    }
    this.homeservice.saveMoleculeData(data).subscribe((response) => {
      this.allMoleculeData = response['message']
      if (this.allMoleculeData == 'success') {
        this.toastService.success('Data saved successfully');
        this.searchMolecule()
        return;
      }
      else {
        this.toastService.error('Data not saved !');
        this.searchMolecule()
        return;
      }
    }, (error) => {
      this.toastService.error(typeof error === 'string' ? error : error.message);
      this.searchMolecule();
    })
  }

  savePolymorph(novePolymorph, ndaNumber, genericName, ncepasses) {
    let data = {
      nda_number: ndaNumber,
      genericized: genericName,
      atc_class: this.searchValue,

    }
    data["nce passed"] = ncepasses
    data["novel polymorph"] = novePolymorph

    // if(!data.nda_number || !data.Generic_name) {
    //   this.toastService.error('Missing required field !');
    //   return;
    // }
    this.homeservice.savenovelpolymorphData(data).subscribe((response) => {
      if (response['message'] == 'success') {
        this.toastService.success('Data saved successfully');
        this.searchMolecule()
        return;
      }
      //   else {
      //     this.toastService.error('Data not saved !');
      //     this.searchMolecule()
      //     return; 
      //   }
      // },(error) => {
      //   this.toastService.error(typeof error === 'string' ? error : error.message);
      //   this.searchMolecule();
    })
  }

  selectedvalue = 'NO';
  onSelected(event, index): void {
    console.log(event.target.value);

    if (event.target.value === "YES") {
      this.allMoleculeData[index].novelPolymorph = true;
      this.allMoleculeData[index]["before NCE-1 Date"] = this.allMoleculeData[index]["before NCE-1 Date"] * 2;
      this.allMoleculeData[index]["After NCE-1 Date"] = this.allMoleculeData[index]["After NCE-1 Date"] * 2;
    } else {
      this.allMoleculeData[index].novelPolymorph = false;
      this.allMoleculeData[index]["before NCE-1 Date"] = this.allMoleculeData[index]["before NCE-1 Date"] / 2;
      this.allMoleculeData[index]["After NCE-1 Date"] = this.allMoleculeData[index]["After NCE-1 Date"] / 2;
    }
    console.log(this.allMoleculeData[index].novelPolymorph);
  }
}
